import Box from "@mui/material/Box";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import TestsmsIcon from "@mui/icons-material/Textsms";
import Button from "designSystem/components/button/Button";
import Placeholder from "designSystem/components/placeholder/Placeholder";
import { useStore } from "csi/state/hooks";
import { observer } from "mobx-react-lite";
import React from "react";

export const CommentsPlaceholder = observer(() => {
	const { commentsStore } = useStore();
	const { startNewComment, isDisabledNewConversation } = commentsStore;

	return (
		<Placeholder
			subtitleMargin={6}
			subtitleProps={{ res: "CommentsPlaceholderText" }}
			titleProps={{ res: "CommentsPlaceholderTitle" }}
		>
			{{
				actions:
					<Button
						design="primary"
						disabled={isDisabledNewConversation}
						onClick={startNewComment}
						res="ConversationNew"
					/>
				,

				image:
					<Box>
						<Box color="grey.100" height={36}>
							<ChatBubbleIcon style={{ fontSize: 36 }} />
						</Box>
						<Box
							color="grey.300"
							height={36}
							ml={9}
						>
							<TestsmsIcon style={{ fontSize: 36, transform: "scale(-1, 1)" }} />
						</Box>
					</Box>,
			}}
		</Placeholder>
	);
});

export default CommentsPlaceholder;